import React,{createContext, useState,useEffect} from 'react';
import {createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut,updateProfile} from 'firebase/auth'
import app from './../../firebase/firebase.config';
const auth = getAuth(app)
export const AuthContext = createContext()
const AuthProvider = ({children}) => {
    const [loading,setLoading] = useState(true)
    const [user,setUser] = useState(null)
    const createUser = (email,password)=>{
        setLoading(true)
       return createUserWithEmailAndPassword(auth,email,password)
    }
    const login = (email,password)=>{
        setLoading(true)
        return signInWithEmailAndPassword(auth,email,password)
    }
    const updateUser =(userInfo)=>{
        return  updateProfile(auth.currentUser,userInfo)
      }
    const logOut =()=>{
        setLoading(true)
        return signOut(auth)
    }
    const googleProvier = new GoogleAuthProvider()
  const googleUser =()=>{
    return  signInWithPopup(auth,googleProvier)
            
  }
    useEffect(()=>{
        const unsubscribe = onAuthStateChanged(auth,currentUser=>{
                setLoading(false)
               console.log(currentUser);
               setUser(currentUser)
           })
           return()=>{
               unsubscribe()
           }
    },[])
    const authInfo ={
        user,
        createUser,
        loading,
        login,
        logOut,
        updateUser,
        googleUser

    }
    return (
        <AuthContext.Provider value={authInfo}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;